module.exports = __webpack_public_path__ + "static/media/Noisey Droplet.d4d9dc1c.mp4";